import { AppProps } from '@wppopen/core'
import { OsProvider } from '@wppopen/react'
import { StrictMode, useEffect } from 'react'
import { OSApp } from './OSApp'
import { initialiseGTM } from 'gtmScript'
const OSRoot = (props: AppProps) => {
  useEffect(() => {
    try {
      initialiseGTM()
    } catch (error) {
      console.error('Error initializing GTM:', error)
    }
  }, [])
  return (
    <StrictMode>
      <OsProvider {...props}>
        <OSApp />
      </OsProvider>
    </StrictMode>
  )
}

export default OSRoot
